module.exports = __webpack_public_path__ + "static/media/logo-black.d80c4067.png";